import { render, staticRenderFns } from "./FunnelChartSchool3.vue?vue&type=template&id=5a0362b7&scoped=true&"
import script from "./FunnelChartSchool3.vue?vue&type=script&lang=js&"
export * from "./FunnelChartSchool3.vue?vue&type=script&lang=js&"
import style0 from "./FunnelChartSchool3.vue?vue&type=style&index=0&id=5a0362b7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0362b7",
  null
  
)

export default component.exports